import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcUsers = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M11.5 7.5c0 1.427-.748 2.68-1.873 3.388a6 6 0 0 1 1.873 1.14V18.5h-9a1 1 0 0 1-1-1v-1a6.002 6.002 0 0 1 3.873-5.612A4 4 0 1 1 11.5 7.5Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M13.5 19.5a1 1 0 0 1 1-1H19a1 1 0 1 1 0 2h-4.5a1 1 0 0 1-1-1Zm0-3.5a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Zm0-3.5a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Z",
  fill: "var(--mds-nav-icon-weak)"
})), "IcUsers");

export { IcUsers };
//# sourceMappingURL=ic-users.js.map
